import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-680e4ca4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment-apple" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Suscripción gestionada por Apple", -1))
const _hoisted_3 = { class: "last-payment payment" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Inicio de suscripción", -1))
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "image" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "plan" }
const _hoisted_9 = { class: "date" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notice" }, " Para cambiar, cancelar o reactivar tu suscripción, dirígete a tu cuenta de Apple ", -1))
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "inline-block" }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            alt: "card",
            src: require('@/assets/images/turquoise-card.svg')
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, " Plan " + _toDisplayString(_ctx.currentSubscription.lastPayType), 1),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.currentSubscription.lastPayDate), 1)
      ])
    ]),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        (!_ctx.canReenableSubscription)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              variant: "turquoise outlined",
              onClick: _ctx.goTo
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: require('@/assets/images/change.svg'),
                  alt: "cambiar tarifa"
                }, null, 8, _hoisted_13),
                _createTextVNode(" Cambiar Tarifa ")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : (_ctx.canReenableSubscription)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                disabled: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: require('@/assets/images/change.svg'),
                    alt: "cambiar tarifa"
                  }, null, 8, _hoisted_14),
                  _createTextVNode(" Cambiar Tarifa ")
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_Button, {
                key: 2,
                variant: "ambar",
                onClick: _ctx.goTo
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: require('@/assets/images/renew.svg'),
                    alt: "cambiar tarifa"
                  }, null, 8, _hoisted_15),
                  _createTextVNode(" Reactivar Suscripción ")
                ]),
                _: 1
              }, 8, ["onClick"]))
      ])
    ])
  ]))
}